<template>
  <div class="row">
    <div class="column column-100 header">
      {{ labels['title'] }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS } from '@/settings'

export default {
  computed: mapState({
    lang: state => state.language,
    labels: state => LABELS[state.language]
  })
}
</script>

<style>
  .oi-donation-form .header {
    text-align: center;
    font-size: 20px;
    padding: 5px 10px!important;
  }
</style>
